import React from 'react';
import { Shield, Lock, Zap, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-brand-blue text-white relative overflow-hidden" data-id="element-117">
      <div className="max-w-4xl mx-auto px-4 text-center relative z-10" data-id="element-118">
        <div className="text-6xl mb-6" data-id="element-119">🏊</div>
        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6" data-id="element-120">
          NATACIÓN 360
        </h2>
        <p className="text-xl md:text-2xl text-blue-100 mb-12 font-medium" data-id="element-121">
          El sistema de planificación N°1 para profesores de natación
          argentinos.
        </p>

        <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 mb-12 border border-white/20" data-id="element-122">
          <p className="text-2xl md:text-3xl font-heading font-bold italic leading-relaxed" data-id="element-123">
            "Porque preparar una buena clase no debería costarte todas las
            noches de la semana."
          </p>
        </div>

        <a href="#pricing" className="inline-block w-full sm:w-auto bg-brand-gold hover:bg-yellow-500 text-gray-900 font-bold text-xl py-5 px-10 rounded-xl shadow-2xl shadow-brand-gold/40 transition-all transform hover:-translate-y-1 mb-8" data-id="element-124">
          💪 QUIERO MI NATACIÓN 360 AHORA
        </a>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-blue-200" data-id="element-125">
          <div className="flex items-center gap-2" data-id="element-126">
            <Shield className="w-4 h-4" data-id="element-127" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-128">
            <Lock className="w-4 h-4" data-id="element-129" /> Pago seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-130">
            <Zap className="w-4 h-4" data-id="element-131" /> Acceso inmediato
          </div>
          <div className="flex items-center gap-2" data-id="element-132">
            <CreditCard className="w-4 h-4" data-id="element-133" /> Tarjetas · Transferencia · MP
          </div>
        </div>
      </div>
    </section>;
}